document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-twins-product]').forEach((productRoot) => {
    const picker = productRoot.querySelector('[data-twins-variant-picker]');
    const variantInput = productRoot.querySelector('[data-twins-variant-id]');
    const price = productRoot.querySelector('[data-twins-product-price]');
    const addButton = productRoot.querySelector('[data-twins-add-button]');
    const addLabel = productRoot.querySelector('[data-twins-add-label]');
    const variantData = productRoot.querySelector('[data-twins-variants]');
 
    if (!picker || !variantInput || !variantData) return;
 
    let variants = [];
    try {
      variants = JSON.parse(variantData.textContent);
    } catch (error) {
      return;
    }
 
    const formatMoney = (amount) => {
      const currency = window.Shopify?.currency?.active || 'GBP';
      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency,
      }).format(amount / 100);
    };
 
    picker.addEventListener('change', () => {
      const variant = variants.find((item) => String(item.id) === picker.value);
      if (!variant) return;
 
      variantInput.value = variant.id;
      if (price) price.textContent = formatMoney(variant.price);
      if (addButton) addButton.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? 'Add to basket' : 'Sold out';
 
      if (variant.featured_image?.src) {
        const primaryImage = productRoot.querySelector('[data-twins-primary-image]');
        if (primaryImage) primaryImage.src = variant.featured_image.src;
      }
 
      const nextUrl = new URL(window.location.href);
      nextUrl.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', nextUrl);
    });
  });
});
 
